export default __webpack_public_path__ + "static/media/connect-bottom.c88a9143.svg";